import React from 'react';
import { components as reactSelectComponents } from 'react-select';
import BaseSingleValue from '../components/base-single-value';

const renderSingleValue = (Component = BaseSingleValue) => {
  const SingleValueComponent = (singleValueProps) => {
    const { data, ...restProps } = singleValueProps;
    return (
      <reactSelectComponents.SingleValue {...restProps} isDisabled={data.disabled}>
        <Component {...data} {...restProps} isDisabled={data.disabled} />
      </reactSelectComponents.SingleValue>
    );
  };

  SingleValueComponent.displayName = 'SingleValueComponent';

  return SingleValueComponent;
};

export default renderSingleValue;
